import { GroupBase } from "react-select";

export function isGroup<Option>(
  option: Option | GroupBase<Option>,
): option is GroupBase<Option> {
  return !(option as unknown as { value: unknown })?.value;
}
